import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Space, Typography } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { DependentData } from '../DependentsPage';

interface InviteDependentProps {
  dependentData: DependentData;
}

export const InviteDependent = ({ dependentData }: InviteDependentProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Space direction="vertical">
      <Typography.Text type="secondary">{t('profile.notRegistered')}</Typography.Text>
      <Button onClick={() => navigate('/dependents/invite', { state: dependentData })}>
        <SendOutlined />
        {t('profile.manageSendInvites')}
      </Button>
    </Space>
  );
};
